import {
  APP_ID,
  EnvironmentProviders,
  inject,
  makeEnvironmentProviders,
} from '@angular/core';
import { MAT_SNACK_BAR_DEFAULT_OPTIONS } from '@angular/material/snack-bar';
import {
  createInjectionToken,
  createNoopInjectionToken,
} from 'ngxtension/create-injection-token';

/**
 * Provides necessary modules and configuration for core functionality
 */
export const coreProviders = [
  {
    provide: MAT_SNACK_BAR_DEFAULT_OPTIONS,
    useValue: {
      duration: 5000,
      horizontalPosition: 'center',
      verticalPosition: 'bottom',
    },
  },
];

export const [injectIsFanPortal] = createInjectionToken(() => {
  return inject(APP_ID) === 'fan-portal';
});

export const [injectAppUrl, provideAppUrl] =
  createNoopInjectionToken<string>('App URL');

export const [injectFanPortalUrl, provideFanPortalUrl] =
  createNoopInjectionToken<string>('Fan Portal URL');

export const [injectControlHubUrl, provideControlHubUrl] =
  createNoopInjectionToken<string>('Control Hub URL');

export const [injectControlHubDesktopUrl, provideControlHubDesktopUrl] =
  createNoopInjectionToken<string>('Control Hub Desktop URL');

export const [injectCheckoutUrl, provideCheckoutUrl] =
  createNoopInjectionToken<string>('Checkout URL');

export function provideAppUrls(
  fanPortalUrl: string,
  controlHubUrl: string,
  controlHubDesktopUrl: string,
  checkoutUrl: string,
): EnvironmentProviders {
  return makeEnvironmentProviders([
    provideFanPortalUrl(fanPortalUrl),
    provideControlHubUrl(controlHubUrl),
    provideControlHubDesktopUrl(controlHubDesktopUrl),
    provideCheckoutUrl(checkoutUrl),
    provideAppUrl(() => {
      switch (inject(APP_ID)) {
        case 'fan-portal':
          return injectFanPortalUrl();
        case 'control-hub':
          return injectControlHubUrl();
        case 'control-hub-desktop':
          return injectControlHubDesktopUrl();
        case 'checkout':
          return injectCheckoutUrl();
        default:
          return '';
      }
    }),
  ]);
}
